<template>
  <ClientOnly>
    <Card>
      <FeedCommentsSimple
        feedType="title"
        :feedId="titleEntity.id"
        :highlightAuthorIds="orgMembers || undefined"
        :highlightAuthorTag="$t('generic.tag.creator')"
      />
    </Card>
  </ClientOnly>
</template>

<script setup lang="ts">
import {
  isCreator,
  isMember,
  isOrg,
  isUser,
  Organization,
  type TitleEntity,
  getId,
} from "~/src/api";

const { titleEntity } = defineProps<{
  titleEntity: TitleEntity;
}>();

const { data: orgMembers, pending } = useAsyncData(async () => {
  const orgId = titleEntity.relationships.find(isOrg)?.id;
  if (!orgId) return [];
  const res = await Organization.get(orgId);
  return res.relationships
    .filter((rel) => isUser(rel) || isCreator(rel) || isMember(rel))
    .map(getId)
    .concat([orgId]);
});
</script>
